import { useState } from "react";
import { Navigation } from "@/components/landing/Navigation";
import { HeroSection } from "@/components/landing/HeroSection";
import { GovernanceStages } from "@/components/landing/GovernanceStages";
import { ProductFeatures } from "@/components/landing/ProductFeatures";
import { IndustryCards } from "@/components/landing/IndustryCards";
import { WaitlistSection } from "@/components/landing/WaitlistSection";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openCalendly = () => {
    window.open('https://calendly.com/connect-productelixir-ai', '_blank');
  };

  return (
    <div className="min-h-screen bg-[#020617] text-white selection:bg-violet-500 selection:text-white">
      <Navigation 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen}
        onRequestDemo={openCalendly}
      />
      <HeroSection onRequestDemo={openCalendly} />
      <GovernanceStages />
      <ProductFeatures />
      <IndustryCards />
      <WaitlistSection />
      <Footer />
    </div>
  );
}
